import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const SelecteursCSS = () =>{


    return(
    
        <div id="articleContent" className="SelecteursCSS">
        <table class="p207010">
          <tr>
                        <td>x + y</td>
                        <td>Cible le Y qui est immédiatement précédé par le X</td>
                        <td>ie7+</td>
                        </tr>
                        <tr>
                            <td>x ~ y</td>
                            <td>Cible le Y qui est précédé par le X (portée plus générale</td>
                            <td>ie7+</td>
                        </tr>
                        <tr>
                            <td>a[title]</td>
                            <td>Ne cible que les balises qui ont un attribut title</td>
                            <td>ie7+</td>
                        </tr>
                        <tr>
                            <td>a[href="http://google.com"]</td>
                            <td>Ne cible que les balises qui ont l'attribut href et cette url (utilisation d'expressions
                                régulières sur l'url varie)</td>
                            <td>ie7+</td>
                        </tr>
                        <tr>
                            <td>a[href*="google"]</td>
                            <td>Ne cible que les balises qui ont l'attribut href et une valeur contenant la chaîne de
                                caractère google</td>
                            <td>ie7+</td>
                        </tr>
                        <tr>
                            <td>a[href^="http"]</td>
                            <td>Ne cible que les balises qui ont l'attribut href et une valeur commencant par la chaîne
                                de caractère http</td>
                            <td>ie7+</td>
                        </tr>
                        <tr>
                            <td>a[href$=".jpg"]</td>
                            <td>Ne cible que les balises qui ont l'attribut href et une valeur se terminant par la
                                chaîne de caractère .jpg</td>
                            <td>ie7+</td>
                        </tr>
                        <tr>
                            <td>a[data-*="image"]</td>
                            <td>"Ajout de notre popre attribut pour par exemple, selectionner toutes les balises a
                                contenant une image data-filetype="image""</td>
                            <td>ie7+</td>
                        </tr>
                        <tr>
                            <td>a[data-info~="external"] a[data-info~=" image"]</td>
                            <td>Cible un attribut qui a une liste de valeurs séparées par un espace</td>
                            <td>ie7+</td>
                        </tr>
                        <tr>
                            <td>input[type=radio]:checked</td>
                            <td>Ne ciblera un élement d'interface utilisateur que s'il a été coché</td>
                            <td>ie9+</td>
                        </tr>
                        <tr>
                            <td>div::after | div::before</td>
                            <td>Générer du contenu autour de l'élément sélectionné</td>
                            <td>ie8+</td>
                        </tr>
                        <tr>
                            <td>div:not(#container)</td>
                            <td>Cible toutes les div sauf celles avec l'id container</td>
                            <td>ie9+</td>
                        </tr>
                        <tr>
                            <td>p:first-line</td>
                            <td>Cible la première ligne d'un élement</td>
                            <td>ie6+</td>
                        </tr>
                        <tr>
                            <td>p:first-letter</td>
                            <td>Cible la première lettre d'un paragraphe </td>
                            <td>ie6+</td>
                        </tr>
                        <tr>
                            <td>li:nth-child(2)</td>
                            <td>Cible le deuxième li</td>
                            <td>ie9+</td>
                        </tr>
                        <tr>
                            <td>li:nth-child(4)</td>
                            <td>Cible tous les quatrièmes élements d'une liste</td>
                            <td>ie9+</td>
                        </tr>
                        <tr>
                            <td>li:nth-last-child(2)</td>
                            <td>Cible l'avant dernier élement d'une liste</td>
                            <td>ie9+</td>
                        </tr>
                        <tr>
                            <td>li:nth-child(odd)</td>
                            <td>Cible les élements impairs</td>
                            <td>ie9+</td>
                        </tr>
                        <tr>
                            <td>li:nth-child(even)</td>
                            <td>Cible les élements pairs</td>
                            <td>ie9+</td>
                        </tr>
                        <tr>
                            <td>ul:nth-of-type(n)</td>
                            <td>Idem que pour le child sans lien de parenté</td>
                            <td>ie9+</td>
                        </tr>
                        <tr>
                            <td>ul:nth-last-of-type(n)</td>
                            <td>Idem que pour le child sans lien de parenté</td>
                            <td>ie9+</td>
                        </tr>
                        <tr>
                            <td>div p:only-child</td>
                            <td>Cible un élement qui est seul enfant de son parent</td>
                            <td>ie9+</td>
                        </tr>
                        <tr>
                            <td>ul:only-of-type</td>
                            <td>Cible un élement qui n'a aucun frère au sein du conteneur parent</td>
                            <td>ie9+</td>
                        </tr>
                        <tr>
                            <td>ul:first-of-type</td>
                            <td>Cible le premier élement de type ul</td>
                            <td>ie9+</td>
                        </tr>
                    </table>

      </div>
    )
}
